export default __webpack_public_path__ + "static/9_eurostyl-46ea8bb0580bd3cbe38fda02c3929d80.png";